// 数子转换千分位
export function numberFormat(x) {
  x = x.toString();
  var pattern = /(-?\d+)(\d{3})/;
  while (pattern.test(x)) x = x.replace(pattern, "$1,$2");
  return x;
}

// 格式化时间
export function timeFormat(date, format) {
  if (date == null || date === "") {
    return "";
  }
  // 填充
  function fillString(num) {
    if (num < 10) {
      return `0${num}`;
    } else {
      return num;
    }
  }
  let result = "";
  // yyyy:MM:dd HH:mm:ss ww
  const dateString = new Date(date);
  const year = dateString.getFullYear();
  const mouth = dateString.getMonth() + 1;
  const day = dateString.getDate();
  const Hour = dateString.getHours();
  const minute = dateString.getMinutes();
  const second = dateString.getSeconds();
  const millisecond = new Date().getMilliseconds();
  if (format) {
    result = format
      .replace(/yyyy/, year)
      .replace(/MM/, fillString(mouth))
      .replace(/dd/, fillString(day))
      .replace(/HH/, fillString(Hour))
      .replace(/mm/, fillString(minute))
      .replace(/ss/, fillString(second))
      .replace(/ww/, fillString(millisecond));
  } else {
    result = `${year}年${mouth}月${day}日`;
  }
  return result;
}
// 格式化时间 2020-00-00 00:00:00 至 2020-00-00 00:00:00
export function timeFormatTo(date) {
  if (date == null || date === "") {
    return "";
  } else {
    let dateArray = date.split(" 至 ");
    return (
      dateArray[0].substring(0, 16) + " 至 " + dateArray[1].substring(0, 16)
    );
  }
}

//格式化两个日期，
export function timeFormatTow(date1, date2) {
  if (date1 == null || date2 == null) {
    return "-";
  }
  if (date1.substring(0, 3) == date2.substring(0, 3)) {
    return (
      this.$timeFormat(date1, "yyyy-MM-dd HH:mm") +
      "至" +
      this.$timeFormat(date2, "MM-dd HH:mm")
    );
  } else {
    return (
      this.$timeFormat(date1, "yyyy-MM-dd HH:mm") +
      "至" +
      this.$timeFormat(date2, "yyyy-MM-dd HH:mm")
    );
  }
}

// 判断是否是一个完整的地址
export function isUrl(value) {
  const urlReg = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/;
  if (!value) {
    return false;
  }
  const result = value.match(urlReg);
  if (result) {
    return true;
  } else {
    return false;
  }
}

// 替换字符串中的图片地址
export function imgHtml(content) {
  let this_ = this;
  if (content == null || content == "") {
    return "";
  }
  content = content.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/gi, function(
    match,
    capture
  ) {
    let c = capture; //地址
    let m = match; //img标签
    if (this_.$isUrl(c)) {
      return m;
    } else {
      let l = c.indexOf("/filesystem/");
      return m.replace(c, this_.$baseUrl + c.substring(l, c.length));
    }
  });
  return content;
}

// 过滤价格
export function priceValue(value) {
  if (!value) {
    return "";
  }
  const result = value.split("￥");
  if (result[1]) {
    return result[1].trim().replace(".00", ""); // 去掉价格.00
  } else {
    return "";
  }
}

//数据小于9时 前面加0
export function zero(value) {
  if (value <= 9) {
    return "0" + value;
  } else {
    return value;
  }
}
// url参数获取
export function getQueryVariable(variable) {
  const query = window.location.search.substring(1);
  const vars = query.split("&");
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split("=");
    if (pair[0] === variable) {
      return pair[1];
    }
  }
  return false;
}

/**
 * cookies值
 * 获取当前登录人员的token值
 */
export function getToken() {
  const tag = this.$getQueryVariable("_role_tag"); //拿到头部指定参数
  if (tag) {
    const tokenKye = this.$cookies.get(tag); //根据唯一值拿存token的key
    if (!this.$isEmpty(tokenKye)) {
      const tokenValue = this.$cookies.get(tokenKye);
      if (!this.$isEmpty(tokenValue)) {
        return tokenValue;
      }
    }
  }
  return null;
}

/**
 * cookies值
 * 删除token值
 */
export function removeToken() {
  const tag = this.$getQueryVariable("_role_tag"); //拿到头部指定参数
  if (tag) {
    const tokenKye = this.$cookies.get(tag); //根据唯一值拿存token的key
    if (!this.$isEmpty(tokenKye)) {
      this.$cookies.remove(tokenKye);
    }
  }
}

/**
 * 组装缓存的key值
 */
export function getKeyInfo(val) {
  const tag = this.$getQueryVariable("_role_tag"); //拿到头部指定参数
  if (tag) {
    const tokenKye = this.$cookies.get(tag); //根据唯一值拿存token的key
    if (!this.$isEmpty(tokenKye)) {
      return val + "_" + tokenKye; //传入的值 + 当前人的token的key
    }
  }
  return val;
}

// 验证码定时器
export function doTimer(second, cb) {
  let timer = null;
  return function doLoop() {
    timer = setTimeout(() => {
      if (second < 1) {
        clearTimeout(timer);
      } else {
        second--;
        cb(second);
        doLoop();
      }
    }, 1000);
  };
}
// 延迟定时器
export const createTimer = (function() {
  let timer = null;
  return {
    getTimer: function doLoop(fn, delay) {
      const time = delay * 1000;
      timer = setTimeout(() => {
        fn(true);
        doLoop.apply(this, arguments);
      }, time);
    },
    cancelTimer: function() {
      clearTimeout(timer);
    }
  };
})();

// 判断手机类型
export const deviceType = (function() {
  const ua = window.navigator.userAgent.toLocaleLowerCase();
  const isIos = /iphone|ipad|ipod/.test(ua);
  const isAndroid = /android/.test(ua);
  return {
    isIos: isIos,
    isAndroid: isAndroid
  };
})();

export function noFind(event) {
  var img = event;
  img.src = "https://pic.cnblogs.com/avatar/1505226/20191123150748.png"; // 默认图片地址
  img.onerror = null; // 控制不要循环展示错误
}

/**
 * 判断是否是微信浏览器
 */
export function isWeixin() {
  var ua = navigator.userAgent.toLowerCase();
  var isWeixin = ua.indexOf("micromessenger") != -1;
  if (isWeixin) {
    return true;
  } else {
    return false;
  }
}

/**
 * 判断数值类型的比较  原因：为了解决   1==1 || 1===1 的问题
 */
export function NumEqual(num_0, num_1) {
  if (num_0 === num_1 || num_0 == num_1) {
    return true;
  } else {
    return false;
  }
}

/**
 * @param {非空验证} value
 */
export function isEmpty(value) {
  if (
    value == "" ||
    value == undefined ||
    (value == "undefined") | (value == "[]") ||
    value == null ||
    value == "null"
  ) {
    return true;
  }
  return false;
}

//关闭页面
export function closePage() {
  window.location.href = "about:blank";
  window.close();
}

/**
 * 毫秒转分钟
 */
export function returnMin(time, n) {
  if (time == null || time == "") {
    return 0;
  } else {
    let mm = Math.floor(time / (60 * 1000)); //分钟
    let ss = Math.floor(time / 1000); //秒
    if (n == null || n == "") {
      return mm;
    }
    if (mm <= 0) {
      return ss + (n != null && n != "" ? " 秒钟" : "");
    } else {
      return mm + (n != null && n != "" ? " 分钟" : "");
    }
  }
}

/**
 * 判断是否有http请求头
 */
export function isHttp(url) {
  if (url == null || url == "") {
    return url;
  }

  // 替换反斜杠为正斜杠
  url = url.replace(/\\/g, "/");

  // 如果后缀是 .pptx，则替换为 .pdf
  if (url.toLowerCase().endsWith(".pptx")) {
    url = url.replace(/\.pptx$/i, ".pdf");
  }

  // 判断是否以 http / https 开头
  if (
    url
      .substring(0, 4)
      .toLowerCase()
      .indexOf("http") >= 0
  ) {
    return url;
  } else {
    return window.configs.API_SRC + url;
  }
}

/**
 * 预览pdf头
 */
export function viewUrlInfo(url) {
  if (url != null && url != "") {
    url = url.replace(/\\/g, "/");
  }
  if (
    url.substring(0, 4).indexOf("http") >= 0 ||
    url.substring(0, 4).indexOf("HTTP") >= 0
  ) {
    return this.$viewUrl + url;
  } else {
    return this.$viewUrl + "" + this.$baseUrl + url;
  }
}

/**
 * 阿拉伯数字转换成中文数字
 */
export function chineseNum(index, tag) {
  let info = [
    "一",
    "二",
    "三",
    "四",
    "五",
    "六",
    "七",
    "八",
    "九",
    "十",
    "十一",
    "十二",
    "十三",
    "十四",
    "十五"
  ];
  if (tag == 1) {
    info = [
      "①",
      "②",
      "③",
      "④",
      "⑤",
      "⑥",
      "⑦",
      "⑧",
      "⑨",
      "⑩",
      "⑪",
      "⑫",
      "⑬",
      "⑭",
      "⑮",
      "⑯",
      "⑰",
      "⑱",
      "⑲",
      "⑳"
    ];
  }
  return info[index];
}

/**
 * 阿拉伯数字转换成字母
 */
export function getABC(index) {
  let info = [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z"
  ];
  return info[index];
}

/**
 * @param {比较两个时间的大小} start send
 */
export function compareTime(start, send) {
  if (start == null) {
    return true;
  } else if (send == null) {
    return false;
  }
  return new Date(start.replace(/-/g, "/")) < new Date(send.replace(/-/g, "/"));
}

/**
 * 获取当前时间的年月日
 * @param {Object}
 */
export function getNewDate() {
  let yy = new Date().getFullYear();
  let mm = new Date().getMonth() + 1;
  let dd = new Date().getDate();
  let hh = new Date().getHours();
  let mf = new Date().getMinutes();
  let ss = new Date().getSeconds();
  return (
    yy +
    "-" +
    this.$zero(mm) +
    "-" +
    this.$zero(dd) +
    " " +
    this.$zero(hh) +
    ":" +
    this.$zero(mf) +
    ":" +
    this.$zero(ss)
  );
}

/**
 * @param {Object} _length
 * 返回相应长度的字母
 */
export function GetRandomLetters(_length) {
  var str = "";
  for (var i = 0; i < _length; i++) {
    if (parseInt(Math.random() * 2, 10)) {
      var num = Math.random() * 26 + 65;
      str += String.fromCharCode(num);
    } else {
      var num = Math.random() * 26 + 97;
      str += String.fromCharCode(num);
    }
  }
  return str;
}

/**
 * @param {Object} url
 * 传入逗号隔开的字符串 返回第一个
 */
export function getUrl(url) {
  if (!this.$isEmpty(url)) {
    return this.$isHttp(url.split(",")[0]);
  } else {
    return this.$isHttp(url);
  }
}

/**
 * @param {Object} type
 * 题型(1单选 2多选 3判断 4:填空题 5:分析题)
 *  SINGLE_QUESTION(1, "单选题"),
 *  MULTIPLE_QUESTION(2, "多选题"),
 *  JUDGMENT_QUESTION(3, "判断题"),
 *  FILL_QUESTION(4, "填空题"),
 *  ANALYSIS_QUESTION(5, "分析题");
 */
export function retQuestionType(type, tag) {
  if (type == 1 || type == "SINGLE_QUESTION") {
    return tag == 1 ? "SINGLE_QUESTION" : "单选题";
  } else if (type == 2 || type == "MULTIPLE_QUESTION") {
    return tag == 1 ? "MULTIPLE_QUESTION" : "多选题";
  } else if (type == 3 || type == "JUDGMENT_QUESTION") {
    return tag == 1 ? "JUDGMENT_QUESTION" : "判断题";
  } else if (type == 4 || type == "FILL_QUESTION") {
    return tag == 1 ? "FILL_QUESTION" : "填空题";
  } else if (type == 5 || type == "ANALYSIS_QUESTION") {
    return tag == 1 ? "ANALYSIS_QUESTION" : "分析题";
  } else {
    return "-";
  }
}

/**
 * 返回性别
 */
export function retSex(type) {
  if (type == "MAN" || type == 1) {
    return "男";
  } else if (type == "WOMAN" || type == 2) {
    return "女";
  } else {
    return "保密";
  }
}

/**
 * @param {Object} type
 * 1	视频 2	PPT 3	PDF 4	链接 5	图文
 */
export function retRresourcesName(type) {
  if (type == 1) {
    return "视频";
  } else if (type == 2) {
    return "PPT";
  } else if (type == 3) {
    return "PDF";
  } else if (type == 4) {
    return "链接";
  } else if (type == 5) {
    return "图文";
  } else {
    return "-";
  }
}

/**
 * @param {Object} type
 * 1:观看视频 2:观看PPT 3:理论测评 4:实训操作步骤 5:报告撰写
 */
export function retTaskName(type) {
  if (type == 1) {
    return "观看视频";
  } else if (type == 2) {
    return "观看PPT";
  } else if (type == 3) {
    return "理论测评";
  } else if (type == 4) {
    return "实训操作步骤";
  } else if (type == 5) {
    return "报告撰写";
  } else {
    return "-";
  }
}
/*
 * @param: fileName - 文件名称
 * @param: 数据返回 1) 无后缀匹配 - false
 * @param: 数据返回 2) 匹配图片 - image
 * @param: 数据返回 3) 匹配 txt - txt
 * @param: 数据返回 4) 匹配 excel - excel
 * @param: 数据返回 5) 匹配 word - word
 * @param: 数据返回 6) 匹配 pdf - pdf
 * @param: 数据返回 7) 匹配 ppt - ppt
 * @param: 数据返回 8) 匹配 视频 - video
 * @param: 数据返回 9) 匹配 音频 - radio
 * @param: 数据返回 10) 其他匹配项 - other
 */
export function matchType(fileName) {
  // 后缀获取
  var suffix = "";
  // 获取类型结果
  var result = "";
  try {
    var flieArr = fileName.split(".");
    suffix = flieArr[flieArr.length - 1];
  } catch (err) {
    suffix = "";
  }
  // fileName无后缀返回 false
  if (!suffix) {
    result = false;
    return result;
  }
  // 图片格式
  var imglist = ["png", "jpg", "jpeg", "bmp", "gif"];
  // 进行图片匹配
  result = imglist.some(function(item) {
    return item == suffix;
  });
  if (result) {
    result = "image";
    return result;
  }
  // 匹配txt
  var txtlist = ["txt"];
  result = txtlist.some(function(item) {
    return item == suffix;
  });
  if (result) {
    result = "txt";
    return result;
  }
  // 匹配 excel
  var excelist = ["xls", "xlsx"];
  result = excelist.some(function(item) {
    return item == suffix;
  });
  if (result) {
    result = "excel";
    return result;
  }
  // 匹配 word
  var wordlist = ["doc", "docx"];
  result = wordlist.some(function(item) {
    return item == suffix;
  });
  if (result) {
    result = "word";
    return result;
  }
  // 匹配 pdf
  var pdflist = ["pdf"];
  result = pdflist.some(function(item) {
    return item == suffix;
  });
  if (result) {
    result = "pdf";
    return result;
  }
  // 匹配 ppt
  var pptlist = ["ppt", "pptx"];
  result = pptlist.some(function(item) {
    return item == suffix;
  });
  if (result) {
    result = "ppt";
    return result;
  }
  // 匹配 视频
  var videolist = ["mp4", "m2v", "mkv", "wmv"];
  result = videolist.some(function(item) {
    return item == suffix;
  });
  if (result) {
    result = "video";
    return result;
  }
  // 匹配 音频
  var radiolist = ["mp3", "wav", "wmv"];
  result = radiolist.some(function(item) {
    return item == suffix;
  });
  if (result) {
    result = "radio";
    return result;
  }
  // 其他 文件类型
  result = "other";
  return result;
}

/**
 * 自定义的合计计算方法
 * @param {Object} param
 * @param {Object} text 显示的名称
 */
export function getSummaries(param, text) {
  const { columns, data } = param;
  const sums = [];
  columns.forEach((column, index) => {
    if (index == 0) {
      sums[index] = text || "总分";
      return;
    }
    const values = data.map(item => Number(item[column.property]));
    if (!values.every(value => isNaN(value))) {
      sums[index] = values.reduce((prev, curr) => {
        const value = Number(curr);
        if (!isNaN(value)) {
          return prev + curr;
        } else {
          return prev;
        }
      }, 0);
    }
  });
  return sums;
}

/**
 * 合并表格
 */
export function arraySpanMethod(key, colSpanNum) {
  //合并合计行
  this.$nextTick(() => {
    if (key) {
      let current = key
        .querySelector(".el-table__footer-wrapper")
        .querySelector(".el-table__footer");
      let cell = current.rows[0].cells;
      for (let i = 0; i < colSpanNum; i++) {
        if (i != 0) {
          cell[i].style.display = "none";
        }
      }
      cell[0].colSpan = colSpanNum;
      cell[0].style.textAlign = "right";
    }
  });
}

/**
 * 下载文件
 * 说明：
 *   1. 统一处理成功 / 服务端报错 / 网络异常 / 超时，任何情况下都会关闭 loading 并给出提示，
 *      避免出现「点了导出转半天没反应、也没有任何提示」；
 *   2. 后端异常时（HTTP != 200，或返回 JSON 错误体）不再下载出一个坏文件，而是把 msg 提示出来；
 *   3. 支持从 Content-Disposition 读取服务端文件名（需要后端暴露该响应头，取不到则用传入的 name）。
 * @param {Object} url //文件地址
 * @param {Object} name //文件名称，为空时取文件名称
 */
export function downLoadFile(url, name) {
  let token = this.$getToken();
  let this_ = this;
  // 导出大文件可能耗时较久，这里给 10 分钟兜底，超时会明确提示而不是一直转圈
  const TIMEOUT = 10 * 60 * 1000;
  let closed = false;
  const loading = this.$loading({
    //开启加载
    lock: true,
    text: "正在下载，请稍候…",
    spinner: "el-icon-loading",
    background: "rgba(0, 0, 0, 0.7)"
  });
  const closeLoading = function () {
    if (closed) return;
    closed = true;
    loading.close(); //关闭加载
  };
  const fail = function (msg) {
    closeLoading();
    this_.$message({ type: "error", message: msg });
  };
  // 读取 blob 文本（服务端异常信息一般是 JSON）
  const readText = function (blob, cb) {
    if (!blob) return cb("");
    try {
      if (typeof FileReader !== "undefined") {
        const reader = new FileReader();
        reader.onload = function () {
          cb(String(reader.result || ""));
        };
        reader.onerror = function () {
          cb("");
        };
        reader.readAsText(blob);
      } else if (typeof blob.text === "function") {
        blob.text().then(cb).catch(function () {
          cb("");
        });
      } else {
        cb("");
      }
    } catch (e) {
      cb("");
    }
  };
  // 从服务端返回体里提取可读的错误信息
  const pickServerMsg = function (text) {
    if (!text) return "";
    try {
      const obj = JSON.parse(text);
      if (obj && (obj.msg || obj.message)) return obj.msg || obj.message;
      if (obj && obj.error) return obj.error;
    } catch (e) {
      // 不是 JSON，多半是 nginx / tomcat 的 HTML 错误页
    }
    return "";
  };
  // 解析 Content-Disposition 里的文件名
  const pickFileName = function (disposition, fallback) {
    if (!disposition) return fallback;
    let m = /filename\*=utf-8''([^;]+)/i.exec(disposition);
    if (m && m[1]) {
      try {
        return decodeURIComponent(m[1]);
      } catch (e) {}
    }
    m = /filename="?([^";]+)"?/i.exec(disposition);
    if (m && m[1]) {
      try {
        return decodeURIComponent(m[1]);
      } catch (e) {
        return m[1];
      }
    }
    return fallback;
  };

  if (this.$isEmpty(url)) {
    closeLoading(); //关闭加载
    this.$message.warning("暂无文件！");
    return;
  } else {
    // 关键修复：接口类下载（/api/**、/jlw/**）必须走 API_ROOT 业务网关，
    // 不能走 $isHttp 默认的 API_SRC（那是图片/附件静态域，请求这些接口会 404，
    // 而旧代码不处理非 200，表现就是「点导出一直转圈、没有任何提示」）。
    // 其余相对路径仍按原逻辑走 API_SRC（附件、图片等静态资源）。
    if (/^https?:\/\//i.test(url)) {
      // 已是完整地址，直接使用
    } else if (/^\/(api|jlw)\//i.test(url)) {
      url = window.configs.API_ROOT + url;
    } else {
      url = this.$isHttp(url);
    }
  }
  if (this.$isEmpty(name)) {
    var first = url.lastIndexOf("."); //取到文件名开始到最后一个点的长度
    var nameL = url.lastIndexOf("/");
    var namelength = url.length; //取到文件名长度
    var filesuffix = url.substring(first + 1, namelength); //截取获得后缀名
    name = (url.substring(nameL + 1, first) || "附件") + "." + filesuffix;
  }

  function saveAs(blob, filename) {
    // 改名字
    if (window.navigator.msSaveOrOpenBlob) {
      navigator.msSaveBlob(blob, filename);
      closeLoading();
    } else {
      var link = document.createElement("a");
      var body = document.querySelector("body");

      link.href = window.URL.createObjectURL(blob);
      link.download = filename;
      closeLoading(); //关闭加载
      // fix Firefox
      link.style.display = "none";
      body.appendChild(link);

      link.click();
      body.removeChild(link);

      window.URL.revokeObjectURL(link.href);
    }
  }

  var xhr = new XMLHttpRequest();
  xhr.open("GET", url, true);
  xhr.responseType = "blob";
  xhr.timeout = TIMEOUT;
  if (!this.$isEmpty(token)) {
    xhr.setRequestHeader("token", token);
  }
  xhr.onload = function () {
    // 服务端异常：把错误信息透出来，不再无提示转圈
    if (xhr.status !== 200) {
      readText(xhr.response, function (text) {
        const msg = pickServerMsg(text);
        fail(msg ? "导出失败：" + msg : "导出失败（HTTP " + xhr.status + "），请稍后重试，或联系管理员查看服务端日志");
      });
      return;
    }
    const blob = xhr.response;
    const contentType = (blob && blob.type) || "";
    // 少数情况下后端异常仍返回 200 + JSON，此时不能当成文件下载
    if (contentType.indexOf("application/json") >= 0 || contentType.indexOf("text/html") >= 0) {
      readText(blob, function (text) {
        const msg = pickServerMsg(text);
        fail(msg ? "导出失败：" + msg : "导出失败：服务端未返回文件内容，请稍后重试");
      });
      return;
    }
    if (!blob || blob.size === 0) {
      fail("导出失败：服务端返回了空文件，请稍后重试");
      return;
    }
    saveAs(blob, pickFileName(xhr.getResponseHeader("Content-Disposition"), name));
  };
  xhr.onerror = function () {
    fail("导出失败：网络异常，请检查网络连接后重试");
  };
  xhr.ontimeout = function () {
    fail("导出超时：数据量较大，建议先按班级或学生筛选后再导出");
  };
  xhr.onabort = function () {
    fail("导出已取消");
  };
  xhr.send();
}

/**
 * POST 参数转 GET
 * @param {Object} param //参数
 */
export function postNoGet(param) {
  let str = "";
  for (let key in param) {
    if (!this.$isEmpty(param[key])) {
      str += key + "=" + param[key] + "&";
    }
  }
  if (!this.$isEmpty(str)) {
    str = "?" + str.slice(0, str.length - 1);
  }
  return str;
}

/**
 * @param {Object} 获取用户头像信息，没有时取默认图
 */
export function getHeadImg() {
  let userInfo = this.$ls.get(this.$getKeyInfo("identityInfo"));
  if (this.$isEmpty(userInfo.headImg)) {
    userInfo = this.$ls.get(this.$getKeyInfo("userInfo"));
  }
  if (!this.$isEmpty(userInfo) && !this.$isEmpty(userInfo.headImg)) {
    return this.$isHttp(userInfo.headImg);
  } else {
    return require("../images/user/user.png");
  }
}

/**
 * @param {Object} str
 * 用于填空题、分析题替换[---]为_______
 */
export function getReplace(str) {
  if (!this.$isEmpty(str)) {
    let arrayHtml = str.split("[---]");
    let htm = "";
    for (let i = 0; i < arrayHtml.length; i++) {
      htm +=
        arrayHtml[i] +
        (i < arrayHtml.length - 1
          ? "<span style='color:#2789E2;'>_____" +
            this.$chineseNum(i, 1) +
            "_____</span>"
          : "");
    }
    return htm;
  } else {
    return "";
  }
}

/**
 * @param {Object} str
 * 用于填空题、分析题返显答案或者选项
 */
export function retAnswer(answer, type) {
  if (type == 4 || type == 5) {
    let obj = JSON.parse(answer),
      htm = "";
    for (let it in obj) {
      htm += it + "：" + obj[it] + "</br>";
    }
    return htm;
  } else {
    return answer;
  }
}

/**
 * @param {Object} num阿拉伯转中文
 */
export function numberfilter(num) {
  const changeNum = [
    "零",
    "一",
    "二",
    "三",
    "四",
    "五",
    "六",
    "七",
    "八",
    "九"
  ]; // changeNum[0] = "零"
  const unit = ["", "十", "百"];
  num = parseInt(num);
  const getWan = temp => {
    const strArr = temp
      .toString()
      .split("")
      .reverse();
    let newNum = "";
    for (var i = 0; i < strArr.length; i++) {
      newNum =
        (i == 0 && strArr[i] == 0
          ? ""
          : i > 0 && strArr[i] == 0 && strArr[i - 1] == 0
          ? ""
          : changeNum[strArr[i]] + (strArr[i] == 0 ? unit[0] : unit[i])) +
        newNum;
    }
    return newNum;
  };
  const overWan = Math.floor(num / 100);
  let noWan = num % 100;
  if (noWan.toString().length < 2) noWan = "0" + noWan;
  let strr = overWan ? getWan(overWan) + "百" + getWan(noWan) : getWan(num);
  if (strr.split("")[0] == "一") {
    if (this.$isEmpty(strr.substring(1))) {
      return strr.split("")[0];
    } else {
      return strr.substring(1);
    }
  } else {
    return overWan ? getWan(overWan) + "百" + getWan(noWan) : getWan(num);
  }
}

export function formatSeconds(value) {
  if (value == null || value == "") {
    return "00 天 00 时 00 分";
  }
  let result = parseInt(value);
  let y =
    Math.floor(result / 86400) < 10
      ? "0" + Math.floor(result / 86400)
      : Math.floor(result / 86400);
  let h =
    Math.floor((result / 3600) % 24) < 10
      ? "0" + Math.floor((result / 3600) % 24)
      : Math.floor((result / 3600) % 24);
  let m =
    Math.floor((result / 60) % 60) < 10
      ? "0" + Math.floor((result / 60) % 60)
      : Math.floor((result / 60) % 60);
  let s =
    Math.floor(result % 60) < 10
      ? "0" + Math.floor(result % 60)
      : Math.floor(result % 60);
  let res = "";
  res += `${y} 天`;
  res += ` ${h} 时`;
  res += ` ${m} 分`;
  return res;
}

//保留两位小数
//功能：将浮点数四舍五入，取小数点后2位
export function toDecimal(x) {
  var f = parseFloat(x);
  if (isNaN(f)) {
    return;
  }
  f = Math.round(x * 100) / 100;
  return f;
}

//制保留2位小数，如：2，会在2后面补上00.即2.00
export function toDecimalx(x, count = 2) {
  var f = parseFloat(x);
  if (isNaN(f)) {
    return false;
  }
  var f = Math.round(x * 100) / 100;
  var s = f.toString();
  var rs = s.indexOf(".");
  if (rs < 0 && count > 0) {
    rs = s.length;
    s += ".";
  }
  while (s.length <= rs + count) {
    s += "0";
  }
  return s;
}

export function formatFloat(src, pos) {
  return Math.round(src * Math.pow(10, pos)) / Math.pow(10, pos);
}

/**
 * @param {Object} parame
 * 用于统计相应模块使用时间
 * param.firstName = "";//一级名称
 * param.secondName = "";//二级名称
 * param.useDuration = "";//单次使用时长（单位：分钟）
 */
export function addSystemUseLog(parame) {
  // const topTime = this.$ls.get(this.$getKeyInfo(parame.firstName +"_"+parame.secondName + '_topTime')); //上次运行的时间
  // var userType = this.$Base64.decode(this.$ls.get(this.$getKeyInfo("userType"))); //1:学生 2：老师
  // if(userType != null){
  //   if(this.$isEmpty(topTime) || (new Date().getTime() - topTime) >= (parame.useDuration * 60 * 1000 - 100)){
  //     this.$ls.set(this.$getKeyInfo(parame.firstName +"_"+parame.secondName  + '_topTime'),new Date().getTime());
  //     if(parame.useDuration < 1){
  //       parame.useDuration = 1;
  //     }
  //     this.$postJSON('/api/studentTeacherSystemUseLogAnalysis/add.do',parame).then((ret) => {
  //       if(ret.code == 0){
  //         console.log("模块定时成功！"+parame);
  //       }else{
  //         console.log("模块定时失败！"+parame);
  //       }
  //     });
  //   }
  // }
}



// WEBPACK FOOTER //
// ./src/common/ulit.js